import React, { useState } from "react";
import bg from "../../assets/Login Page/Desktop/Login Page _ Desktop Background.svg";
import bgmb from "../../assets/Login Page/Mobile/Login Page _ Mobile Background.svg";
import logo from "../../assets/Login Page/Desktop/Logo.png";
import artwork1 from "../../assets/Login Page/Desktop/Artwork 1.png";
import artwork2 from "../../assets/Login Page/Desktop/Artwork 2.png";
import "./Login.css";
import Grid from "@mui/material/Grid";
import { LoginForm } from "./LoginForm";
import { OtpLogin } from "./OtpLogin";
import { Fpassword } from "./Fpassword";
import { useLocation } from "react-router-dom";
import {
  logoutAuth,
} from "../../redux-toolkit/features/auth/authSlice";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { logoutTheme } from "../../redux-toolkit/features/theme/themeSlice";
import { persistor } from "../../redux-toolkit/store";

export const Login = ({ onLoginSuccess }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [, setStatus] = useState(true);
  const [otpLogin, setOtpLogin] = useState(null);
  const [showEmailForm, setShowEmailForm] = useState(false);

  useEffect(() => {
    persistor.pause();
    dispatch(logoutTheme());
    dispatch(logoutAuth());
    // Clear persisted app state only — do not wipe sessionStorage.
    // App / other flows may use tab-scoped keys; clearing them broke
    // session continuity after login (refresh / new tab).
    localStorage.clear();
  }, []);
  return (
    <>
      <div className="login">
        <img src={bg} className="login__img disableTablet" alt="" />
        <img src={bgmb} className="login__img disableDesktop" alt="" />
        <div className="login__overlay">
          {otpLogin ? (
            <OtpLogin
              email={otpLogin.email}
              id={otpLogin.id}
              password={otpLogin.password}
              rememberFlag={otpLogin.rememberFlag}
              onBack={() => {
                setShowEmailForm(true);
                setOtpLogin(null);
              }}
              onLoginSuccess={onLoginSuccess}
            />
          ) : (
          <div className="containerlogin">
            <Grid container alignItems="center" justifyContent="center">
              <Grid className="disableTablet" item lg={6}>
                <div className="login__left">
                  <h1>
                    Welcome to the <br /> Growth Community
                  </h1>
                  <img
                    src={artwork1}
                    className="login__leftimg"
                    width="60%"
                    alt="artwork1"
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <div className="login__right">
                  <img
                    src={logo}
                    className="login__rightimg"
                    width="32%"
                    alt="quest logo"
                  />
                  {location.pathname === "/login" && (
                    <LoginForm
                      onLoginSuccess={onLoginSuccess}
                      onMfaRequired={setOtpLogin}
                      startWithEmail={showEmailForm}
                      setStatus={setStatus}
                    />
                  )}
                  {(location.pathname === "/forgot-password" ||
                    location.pathname === "/send-mail") && (
                    <Fpassword setStatus={setStatus} />
                  )}
                  {/* {location.pathname === `/reset-password/${id}/${token}` && (
                    <Respassword token={token} />
                  )} */}
                </div>
                <img
                  src={artwork2}
                  className="login__leftartwork"
                  width="70px"
                  alt="quest logo"
                />
              </Grid>
              <p className="login__powered">
                Powered by &nbsp;
                <a
                  href="https://www.sliqgroup.com"
                  rel="noreferrer"
                  target="_blank"
                >
                  <b>Sliq Group</b>
                </a>
              </p>
            </Grid>
          </div>
          )}
        </div>
      </div>
    </>
  );
};
